export default {
    name: 'vi',
    messages: {
        _default: field => `Giá trị của ${field} không đúng.`,
        after: (field, [target]) => `${field} phải xuất hiện sau ${target}.`,
        alpha: field => `${field} chỉ có thể chứa các kí tự chữ.`,
        alpha_dash: field => `${field} có thể chứa các kí tự chữ (A-Z a-z), số (0-9), gạch ngang (-) và gạch dưới (_).`,
        alpha_num: field => `${field} chỉ có thể chứa các kí tự chữ và số.`,
        alpha_spaces: field => `${field} chỉ có thế chứa các kí tự và khoảng trắng.`,
        before: (field, [target]) => `${field} phải xuất hiện trước ${target}.`,
        between: (field, [min, max]) => `${field} phải có giá trị nằm trong khoảng giữa ${min} và ${max}.`,
        confirmed: (field, [confirmedField]) => `${field} khác với ${confirmedField}.`,
        credit_card: field => `Đã điền ${field} không chính xác.`,
        date_between: (field, [min, max]) => `${field} phải có giá trị nằm trong khoảng giữa  ${min} và ${max}.`,
        date_format: (field, [format]) => `${field} phải có giá trị dưới định dạng ${format}.`,
        decimal: (field, [decimals = '*'] = []) =>
            `${field} chỉ có thể chứa các kí tự số và dấu thập phân${!decimals || decimals === '*' ? '' : ' ' + decimals
            }.`,
        digits: (field, [length]) =>
            `Trường ${field} chỉ có thể chứa các kí tự số và bắt buộc phải có độ dài là ${length}.`,
        dimensions: (field, [width, height]) =>
            `${field} phải có chiều rộng ${width} pixels và chiều cao ${height} pixels.`,
        email: field => `${field} sai định dạng.`,
        excluded: field => `${field} phải chứa một giá trị hợp lệ.`,
        ext: field => `${field} phải là một tệp.`,
        image: field => `Trường ${field} phải là một ảnh.`,
        included: field => `${field} phải là một giá trị.`,
        ip: field => `${field} phải là một địa chỉ ip hợp lệ.`,
        max: (field, [length]) => `${field} không thể có nhiều hơn ${length} kí tự.`,
        max_value: (field, [max]) => `${field} phải nhỏ hơn hoặc bằng ${max}.`,
        mimes: field => `${field} phải chứa kiểu tệp phù hợp.`,
        min: (field, [length]) => `${field} phải chứa ít nhất ${length} kí tự.`,
        min_value: (field, [min]) => `${field} phải lớn hơn hoặc bằng ${min}.`,
        numeric: field => `${field} chỉ có thể có các kí tự số.`,
        regex: field => `${field} có định dạng không đúng.`,
        required: field => `${field} không được để trống`,
        requiredTrim: field => `${field} không được để trống`,
        date_required: field => `${field} không được để trống`,
        size: (field, [size]) => `${field} chỉ có thể chứa tệp nhỏ hơn ${formatFileSize(size)}.`,
        url: field => `${field} không phải là một địa chỉ URL hợp lệ.`,
        notSelectParent: field => `Không được chọn chỉ tiêu cha.`,
        forceSelection: field => `${field} không đúng. Vui lòng chọn ${field} trong danh sách`,
        selectionAccount: field =>
            `${field} chưa có trong danh mục tài khoản ngầm định. Vui lòng vào Hệ thống\\Tùy chọn\\Tùy chọn chung\\Tài khoản, Bỏ chọn Hạn chế tài khoản khi nhập chứng từ.`,
        emailMultiple: field => `Địa chỉ ${field} không hợp lệ.`,
        taxCode: field => `Mã số thuế không hợp lệ`,
        phoneEmail: field => `${field} sai định dạng.`,
        phone: field => `${field} sai định dạng.`,
        requiredNumber: field => `${field} không được bỏ trống.`,
        requiredNumberMore0: field => `${field} phải lớn hơn 0.`,
        requiredIsNumber: field => `${field} sai định dạng.`,
        positiveNumber: field => `${field} không được nhập nhỏ hơn 1.`,
        validateFromDate: 'Từ ngày phải nhỏ hơn hoặc bằng đến ngày',
        validateToDate: 'Đến ngày phải lớn hơn hoặc bằng từ ngày',
        ValidateRole: 'Bạn không có quyền thực hiện chức năng này.',
        ValidateEditOrganizationRole: 'Bạn không có quyền chỉnh sửa cơ cấu tổ chức. Vui lòng liên hệ người dùng có quyền Quản trị để được phân quyền.',
        validateDateRange: field => `Xuất khẩu không được vượt quá ${field} ngày.`,
        validateDateRange3Month: 'Xuất khẩu hóa đơn không được vượt quá 3 tháng.',
        validateDateRange1Year: 'Xuất khẩu hóa đơn không được vượt quá 1 năm.',
        prefixemail: field => `Định dạng email không thể tồn tại nhiều hơn 1 kí tự @`,
        specialemail: field =>
            `Chương trình chỉ cho phép lưu email chứa các ký tự: từ A đến Z, từ 0 đến 9, dấu chấm, dấu ngạch ngang và dấu gạch dưới`,
        charactertext: field => `Bạn không được nhập kí tự đặc biệt <,>,...`,
        customRequired: field => `${field} không được để trống.`,
        invalidWebsite: field => `Link website tra cứu không hợp lệ`,
        link: field => `Link website tra cứu không hợp lệ`,
        containData: field => `${field} không tồn tại trong danh sách`,
        autocompleteCombobox: field => `${field} không tồn tại trong danh sách`,
        taxcodeWorking: field => 'Vui lòng nhập tài khoản là MST trùng với MST của đơn vị đang làm việc.',
        identityNumberWorking: field => 'Vui lòng nhập tài khoản MST/CCCD trùng với MST/CCCD của đơn vị đang làm việc.',
        requiredNumberLess0: field => `${field} phải nhỏ hơn 0.`,
        validateStartDate: 'Ngày bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc',
        validateEndDate: 'Ngày kết thúc phải lớn hơn hoặc bằng ngày bắt đầu',
        templateNo: field => 'Nhập mẫu số của hóa đơn theo NĐ123, NĐ70',
        seriesWithoutCode: field => `Nhập ký hiệu của hóa đơn không mã theo NĐ123, NĐ70`,
        rangeDateDuplicate: field => 'Các khoảng thời gian không được trùng nhau',
        excessiveLength: field => `${field} không được lớn hơn 1000 ngày.`,
        excessiveLength1: field => `${field} không được lớn hơn 1000 ngày kể từ ngày lập hóa đơn.`,
        validateMaxLengthStick: 'Chỉ được chọn tối đa 10 nhãn cho 3 bộ lọc Nhãn dán 1, Nhãn dán 2, Nhãn dán 3.',
        validateExistList: field => `${field} không tồn tại trong danh sách`,
        identificationNumber: field => 'CCCD chủ hộ không hợp lệ',
        taxCodeOrIdentification: field => `${field} không hợp lệ`,
        validateMinDate: (minDate) => `Từ ngày phải lớn hơn hoặc bằng ${minDate}`,
        sameasemail: field => `${field} không được trùng với địa chỉ email cũ`
    }
};